import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiList, { ListClassKey as MuiListClassKey } from "@material-ui/core/List";


export type ListClassKey = MuiListClassKey;

export interface ListProps
    extends StandardProps<React.HTMLAttributes<HTMLUListElement>, ListClassKey> {
    component?: React.ReactType<ListProps>;
    dense?: boolean;
    disablePadding?: boolean;
    subheader?: React.ReactElement<any>;
}


class List extends React.PureComponent<ListProps> {
    render() {
        const { ...props } = this.props;
        return <MuiList {...props}>
            {this.props.children}
        </MuiList>;
    }
}

export default List;